import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class FuelTankGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var fuelTankGrid = this;
		setTimeout(function(){
			fuelTankGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var fuelTankGrid = this;		
		fuelTankGrid.tanks = [];
				
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [				
				{
					tag: 'vaadin-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',									
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'vaadin-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,						
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'vaadin-button',
					itemid: 'delete',
					theme: 'error primary',										
					'class': 'spacer-toolbar-item',
					style: 'float: right;',					
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}														
			]
		});		

		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},
			children: [								
				{						
					path: 'tankId',
					header: 'Id',
					width: '7em'
				},	
				{						
					path: 'fuelType',
					header: 'Fuel Type',
					width: '7em'
				},
				{						
					path: 'tankCapacity',
					header: 'Capacity',
					width: '7em'
				},
				{
					path: 'quantityUOM',
					header: 'Units',
					width: '7em'					
				},
				{						
					path: 'actual',
					header: 'Actual Capacity',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}					
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		fuelTankGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			grid.activeItem = null;
			grid.items = fuelTankGrid.tanks.slice(0);	
		};
		actionRefresh();
		
		fuelTankGrid.actionRefresh = actionRefresh;
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Tank' : 'Add Tank',
				icon: 'vaadin:edit',				
				width: 600,
				height: 400,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',											
											label: 'Fuel Type',
											name: 'fuelType',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											value: 'DSL',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('FuelType').then(function (data) {
													combo.items = data;
													combo.required = true;
												});
											}
										},
										{
											tag: 'vaadin-number-field',										
											name: 'tankCapacity',
											label: 'Capacity',
											required: true,
											min: 1,
											max: 1000
										},
										{
											tag: 'vaadin-checkbox',										
											name: 'actual',
											label: 'Actual',
											maxLength: 255
										},
										{
											tag: 'vaadin-combo-box',											
											label: 'Fuel Quantity UOM',
											name: 'quantityUOM',
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: 'GALLON',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('FuelQuantityUOM').then(function (data) {
													combo.items = data;
													combo.required = true;
												});
											}
										},																			
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', (record ? ' Update' : ' Add'))
													],
													listeners: {
														click: function() {															
																		
															var data = formPanel.getData();
															if (record) {
																record.fuelType = data.fuelType;
																record.tankCapacity = data.tankCapacity;
																record.actual = data.actual;
																record.quantityUOM = data.quantityUOM;
															} else {																
																fuelTankGrid.tanks.push(data);																													
																actionSetTankOrder();
															}
															actionRefresh();
															
															addEditWin.close();
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						if (record) {	
							formPanel.load(record);
						}
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
			var tanks = [];		
			
			fuelTankGrid.tanks.forEach(function(tank){
				if (tank.tankId !== record.tankId) {
					tanks.push(tank);
				}
			});
			
			fuelTankGrid.tanks = tanks;
			actionSetTankOrder();
			actionRefresh();
		};	
		
		var actionSetTankOrder = function() {
			var idIndex = 1;
			fuelTankGrid.tanks.forEach(function(tank){
				tank.tankId = idIndex;
				idIndex++;
			});			
		};
		
	}
	
	updateTanks(tanks) {
		var fuelTankGrid = this;	
		//delay (often it the load occurs before the render)
		setTimeout(function(){
			fuelTankGrid.tanks = tanks || [];		
			fuelTankGrid.actionRefresh(); 
		}, 50);		
	}
	
	getTanks() {
		var fuelTankGrid = this;	
		return fuelTankGrid.tanks;		
	}
	
}
customElements.define('dl-fueltank-grid', FuelTankGrid);